import { ReportingGrain, ReportingMetric } from '@eluve/api-contract';

/**
 * Wire value sent as the `metric` query param. Only shapes the response's
 * legacy numerator/denominator pair — the UI derives both headline ratios
 * (adoption and note acceptance) from the raw counts client-side.
 */
export const DEFAULT_METRIC: ReportingMetric = 'usage';

/**
 * Whether the bucket's period is still running (today falls inside it).
 * "Today" is taken in the report timezone — the server buckets by it, so
 * using the browser clock would disagree near bucket boundaries.
 */
export const isBucketIncomplete = (
  bucketStart: string,
  grain: ReportingGrain,
  timezone: string,
): boolean => {
  const end = new Date(`${bucketStart}T00:00:00Z`);
  if (grain === 'day') {
    end.setUTCDate(end.getUTCDate() + 1);
  } else if (grain === 'week') {
    end.setUTCDate(end.getUTCDate() + 7);
  } else {
    end.setUTCMonth(end.getUTCMonth() + 1);
  }
  const todayIso = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
  }).format(new Date());
  return end.toISOString().slice(0, 10) > todayIso;
};
